import {ReactElement} from "react";
import {PageDto} from "../../domain/PageDto";
import {CashDividend} from "../../domain/dividend/CashDividend";
import {useGetCashDividendsMonitor} from "../../application/CashDividendService";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {RefreshDataFunction} from "../../components/types/RefreshDataFunction";
import CashDividendHistoryComponent from "../../components/CashDividendHistoryComponent";

export default function CashDividendsMonitorPage(): ReactElement {

    const dividends: RefreshDataFunction<PageDto<CashDividend>> = useGetCashDividendsMonitor();

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between"
                }}>
                <Grid size={{ xs: 12, md: 10, lg: 10 }}>
                    <Title>Simcorp Dimension Dividend Problems</Title>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <CashDividendHistoryComponent
                    dividends={ dividends.data }
                    loading={ dividends.loading }
                    searchFunction={ () => { void dividends.apiFunction(); } }/>
            </Grid>
        </Container>
    );
}